import React from 'react';
import classNames from 'classnames';
export const Tr = ({ children, className }) => (React.createElement("tr", { className: classNames('', className) }, children));
